import React from 'react';
import ReactLoading from 'react-loading';

export default function (props) {
    return (
        <div className="text-center row">
            <div className="col-4"/>
            <div className="row col-4 py-5">
            <ReactLoading
                type={'bubbles'}
                color={'#459BD8'}
                height={54}
                width={75}
            />
            <h6 className="mt-4 "><strong>{props.title}</strong></h6>
            </div>
            <div className="col-4"/>
        </div>
    )
}